export default "__VITE_ASSET__DzfswSFS__"